var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{ref:"timeline",staticClass:"timeline"},_vm._l((_vm.eventos),function(evento,index){return _c('evento-timeline',{key:`evento-${index}`,attrs:{"evento":evento,"index":index}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }